import { render } from "./index.vue?vue&type=template&id=234268a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=234268a2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-234268a2"

export default script